import { useTranslation } from 'react-i18next'
import './DashboardPage.scss'
import { EngineWidget } from '../../../components'
import { useAppConfig } from '../../../Contexts/AppConfigContext'
import { useEffect, useState } from 'react'
import { HistoryItem } from '@beds2b-group/reusable-components/dist/types'
import { fetchActiveNews, fetchBookingList, fetchUserHistory } from '../../../api/repositoryEP'
import { useBookingEngineContext } from '../../../Contexts/EngineDataContext'
import { getAvailableHotels, searchCoincidencesForWidget } from '../../../utils/utils'
import { Button, Card, GetProp, List, Table, Tooltip } from 'antd'
import { useSessionData } from '../../../Contexts/SessionDataContext'
import BookingInfo, { BookingFilteData, SmallBookingDataList } from '../../../models/BookingInfo'
import { ClockCircleOutlined, EyeOutlined, LikeOutlined, NotificationFilled, ScheduleFilled } from '@ant-design/icons'
import { NewsData, NewsFilter } from '../../../models/NewsInfo'
import Meta from 'antd/es/card/Meta'
import { useNavigate } from 'react-router-dom'
import HTMLReactParser from 'html-react-parser'
import { GetFormattedUrl } from '../../../utils/urls'
import MoneyComponent from '../../../components/common/MoneyComponent/MoneyComponent'

const DashboardgPage = (): JSX.Element => {
  const appConfig = useAppConfig()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const userSessionData = useSessionData()
  const bookingEngineContext = useBookingEngineContext()

  const [userHistory, setUserHistory] = useState<Array<HistoryItem>>([])
  const getUserHistory = () => {
    fetchUserHistory().then((response) => {
      if (response) {
        setUserHistory(response.data)
      } else {
        setUserHistory([])
      }
    })
  }

  const [searchCoincidences, setSearchCoincidences] = useState<Array<any>>([])

  const columnsLastBookings: GetProp<typeof Table<BookingInfo>, 'columns'> = [
    {
      title: 'Locator',
      dataIndex: 'locator',
      key: 'locator',
      align: 'center'
    },
    {
      title: 'Hotel Name',
      dataIndex: 'hotelName',
      key: 'hotelName',
      align: 'center'
    },
    {
      title: 'Owner Name',
      dataIndex: 'ownerName',
      key: 'ownerName',
      align: 'center'
    },
    {
      title: 'PVP',
      dataIndex: 'pvp',
      key: 'pvp',
      align: 'center',

      render: (value, record) => (
        <span>
          <MoneyComponent amountOriginal={value} currencyOriginal={record?.currencySymbol} />

        </span>
      )
    },
    {
      title: 'Functions',
      dataIndex: 'locator',
      width: '25px',
      align: 'center',
      key: 'functions',
      render(value, record, index) {
        return (
          <Button
            onClick={() => {
              navigate(GetFormattedUrl(`private/customer-voucher/${value}`))
            }}
            type="text">
            <EyeOutlined style={{ color: 'var(--primary-app-color)' }} />
          </Button>
        )
      }
    }
  ]

  const columnsPostponedBookings: GetProp<typeof Table<BookingInfo>, 'columns'> = [

    {
      title: 'Hotel Name',
      dataIndex: 'hotelName',
      key: 'hotelName',
      align: 'center'
    },
    {
      title: 'Owner Name',
      dataIndex: 'ownerName',
      key: 'ownerName',
      align: 'center'
    },
    {
      title: 'PVP',
      dataIndex: 'pvp',
      key: 'pvp',
      align: 'center',

      render: (value, record) => (
        <span>
          <MoneyComponent amountOriginal={value} currencyOriginal={record?.currencySymbol} />

        </span>
      )
    },
    {
      title: 'Functions',
      dataIndex: 'locator',
      width: '25px',
      align: 'center',
      key: 'functions',
      render(value, record, index) {
        return (
          <Tooltip title={t('helper.retry-postponed-booking')}>
            <Button
              onClick={() => {
                navigate(GetFormattedUrl(`private/booking-page`), { state: { bookingId: record.bookingId } })
              }}
              type="text">
              <ClockCircleOutlined style={{ color: 'orange' }} />
            </Button>
          </Tooltip>

        )
      }
    }
  ]





  const getSearchCoincidences = (v: string) => {
    if (v.length < 3) return setSearchCoincidences([])

    var coincidences = searchCoincidencesForWidget(appConfig.config.hotels, v)

    setSearchCoincidences(coincidences)
  }

  const [availableDestinations, setAvailableDestinations] = useState<Array<any>>([])
  const getAvilableDestinations = () => {
    setAvailableDestinations(getAvailableHotels(appConfig.config.hotels))
  }


  const [loadingDataActiveBookingsInfo, setLoadingDataActiveBookingsInfo] = useState<boolean>(false)
  const [loadingDataPostponedBookingsInfo, setLoadingDataPostponedBookingsInfo] = useState<boolean>(false)

  const [bookingActiveListInfo, setBookingActiveListInfo] = useState<SmallBookingDataList>({
    elements: [],
    totalRecords: 0,
    totalComission: 0,
    totalPvp: 0
  })
  const [bookingPostponedListInfo, setBookingPostponedListInfo] = useState<SmallBookingDataList>({
    elements: [],
    totalRecords: 0,
    totalComission: 0,
    totalPvp: 0
  })


  const [news, setNews] = useState<{ elements: NewsData[]; prefix: string }>({
    elements: [],
    prefix: ''
  })
  const [loadingNews, setLoadingNews] = useState<boolean>(false)
  const getBookingsActive = (): void => {
    const filter = {
      numRecords: 4,
      page: 1,
      userId: userSessionData.userData.id,
      status: 'active'
    } as BookingFilteData

    setLoadingDataActiveBookingsInfo(true)
    fetchBookingList(filter)
      .then((response) => {
        if (response?.type === 1 && response.data) {
          const responseBookings = response.data as SmallBookingDataList
          setBookingActiveListInfo(responseBookings)
        } else {
          setBookingActiveListInfo({
            elements: [],
            totalRecords: 0,
            totalPvp: 0,
            totalComission: 0
          })
        }
      })
      .finally(() => {
        setLoadingDataActiveBookingsInfo(false)
      })
  }


  const getBookingsPostponed = (): void => {
    const filter = {
      numRecords: 4,
      page: 1,
      userId: userSessionData.userData.id,
      status: 'postponed'
    } as BookingFilteData

    setLoadingDataPostponedBookingsInfo(true)
    fetchBookingList(filter)
      .then((response) => {
        if (response?.type === 1 && response.data) {
          const responseBookings = response.data as SmallBookingDataList
          setBookingPostponedListInfo(responseBookings)
        } else {
          setBookingPostponedListInfo({
            elements: [],
            totalRecords: 0,
            totalPvp: 0,
            totalComission: 0
          })
        }
      })
      .finally(() => {
        setLoadingDataPostponedBookingsInfo(false)
      })
  }



  const getNews = async (): Promise<void> => {
    setLoadingNews(true)

    const filter = {
      isFeatured: true,
      numRecords: 3,
      page: 1,
      allInOrder: true
    } as NewsFilter

    const response = await fetchActiveNews(filter)
    if (response?.type === 1) {
      setNews(response.data)
    }
    setLoadingNews(false)
  }
  const navigateToNew = (id: string) => navigate(GetFormattedUrl(`private/news-page/${id}`))
  useEffect(() => {
    getUserHistory()
    getBookingsActive()
    getBookingsPostponed()
    getNews()
    bookingEngineContext.clearContext()
  }, [])

  useEffect(() => {
    if (!appConfig?.config?.hotels) return

    setAvailableDestinations(
      getAvailableHotels(appConfig.config.hotels)
    )

  }, [appConfig])


  return (
    <div className="dashboard-page">
      <div className="booking-widget">
        <section id="finder">
          <EngineWidget
            cleanForm={false}
            userHistory={userHistory}
            onGetCoincidences={getSearchCoincidences}
            searchCoincidences={searchCoincidences}
            availableDestinations={availableDestinations}
          />
        </section>
        <section className="info-b2b-pro-container" id="info-b2b-pro">
          <Table<BookingInfo>
            id="post-bookings"
            loading={loadingDataPostponedBookingsInfo}
            columns={columnsPostponedBookings}
            dataSource={bookingPostponedListInfo.elements.filter(booking => booking.statusName === 'postponed')}
            bordered
            size="small"
            pagination={false}
            locale={{
              emptyText: (
                <div className="empty-state">
                  <LikeOutlined className="iconLike" />
                  <p className="empty-text"> {t('dashboard.info-beds2b.empty-post-bookings')}</p>
                </div>
              )
            }}
            title={() => (
              <span>
                <ScheduleFilled style={{ fontSize: '20px', color: 'var(--primary-app-color)' }} />{' '}
                <strong> {t('dashboard.info-beds2b.header-post-bookings')}</strong>{' '}
              </span>
            )}
            footer={() => (
              <div className="container-button-see-all">
                {' '}
                <Button
                  onClick={() => navigate(GetFormattedUrl(`private/booking-page`))}
                  style={{ color: 'var(--primary-app-color)' }}
                  type="text">
                  {t('dashboard.info-beds2b.see-all')}
                </Button>
              </div>
            )}
          />
          <Table<BookingInfo>
            id="last-bookings"
            size="small"
            loading={loadingDataActiveBookingsInfo}
            columns={columnsLastBookings}
            dataSource={bookingActiveListInfo.elements}
            bordered
            locale={{
              emptyText: (
                <div className="empty-state">
                  <LikeOutlined className="iconLike" />
                  <p> {t('dashboard.info-beds2b.empty-last-bookings')}</p>
                </div>
              )
            }}
            pagination={false}
            title={() => (
              <span>
                <ScheduleFilled
                  className="iconLike"
                  style={{ fontSize: '20px', color: 'var(--primary-app-color)' }}
                />{' '}
                <strong>{t('dashboard.info-beds2b.header-last-bookings')}</strong>
              </span>
            )}
            footer={() => (
              <div className="container-button-see-all">
                <Button
                  style={{ color: 'var(--primary-app-color)' }}
                  onClick={() => navigate(GetFormattedUrl(`private/booking-page`))}
                  type="text">
                  {t('dashboard.info-beds2b.see-all')}
                </Button>
              </div>
            )}
          />
        </section>
        <section id="last-news">
          <div className="container-title-last-news">
            <NotificationFilled style={{ fontSize: '20px', color: 'var(--primary-app-color)' }} />
            <h3>{t('dashboard.info-beds2b.title-last-news')}</h3>
          </div>
          <List
            grid={{
              gutter: 15,
              xs: 1,
              sm: 1,
              md: 2,
              lg: 2,
              xl: 3,
              xxl: 3
            }}
            locale={{
              emptyText: (
                <div className="empty-state-news">
                  <LikeOutlined className="iconLike" />
                  <p> {t('dashboard.info-beds2b.empty-news')}</p>
                </div>
              )
            }}
            loading={loadingNews}
            dataSource={news?.elements ?? []}
            renderItem={(item: NewsData) => (
              <List.Item>
                <Card
                  onClick={() => {
                    navigateToNew(item.id)
                  }}
                  hoverable
                  style={{ minWidth: 200, flex: 1 }}
                  cover={
                    <div
                      style={{
                        backgroundImage: `url(${news.prefix + item.img})`,
                        height: 200,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat'
                      }}></div>
                  }>
                  <Meta
                    title={item.title}
                    description={
                      <>
                        <div style={{ height: '50px', overflow: 'clip', marginBottom: '5px' }}>
                          {HTMLReactParser(item.description ?? '')}
                        </div>
                        <Button
                          style={{
                            color: 'white',
                            backgroundColor: 'var(--primary-app-color)',
                            width: '100%'
                          }}
                          type="primary">
                          {t('dashboard.info-beds2b.see-news')}
                        </Button>
                      </>
                    }
                  />
                </Card>
              </List.Item>
            )}
          />
        </section>
      </div>
    </div>
  )
}

export default DashboardgPage
